import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pt-sign-actions',
  template: `
    <div class="sign-action">
      <button
        *ngIf="showCancel"
        class="btn btn-outline-secondary btn-sm w-100"
        type="button"
        data-testid="btn-cancel"
        (click)="onCancel.emit()"
        [disabled]="!enabledCancel"
      >
        {{ cancelLabel }}
      </button>
      <div class="separator" *ngIf="showCancel && showConfirm"></div>

      <button
        *ngIf="showConfirm"
        class="btn btn-primary btn-sm w-100"
        type="button"
        (click)="onConfirm.emit()"
        data-testid="btn-confirm"
        autofocus
        [disabled]="!enabledConfirm">
        {{ confirmLabel }}
      </button>
    </div>
    <div class="forgot-password">
      <a
        *ngIf="showForgotPassword"
        class="text-secondary"
        (click)="onForgotPassword.emit()">
        {{ forgotLabel }}
      </a>
    </div>

  `,
  styles: [`
  .sign-action { display: flex; justify-content: space-between; flex-direction: row; }
  .separator { width: 30px;}
  .forgot-password { width: 100%; margin-top:5px; cursor: pointer; text-align: right;}
  `]
})
export class SignActionsComponent {
  @Input() confirmLabel: string;
  @Input() enabledConfirm = true;
  @Input() showConfirm: boolean;

  @Input() cancelLabel: string;
  @Input() enabledCancel = true;
  @Input() showCancel: boolean;

  @Input() forgotLabel: string;
  @Input() showForgotPassword: boolean;

  @Output() onConfirm = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  @Output() onForgotPassword = new EventEmitter();
}
